import commonMapping from "@/mapping/common";
const isp_list = [
  {
    value: "orange_dhcp",
    config: "orange_france_dhcp",
    label: "orange_dhcp",
  },
  {
    value: "orange_pppoe",
    config: "orange_france_pppoe",
    label: "orange_pppoe",
  },
  {
    value: "movistar_spain_pppoe",
    config: "movistar_spain_pppoe",
    label: "movi_spain_dhcp",
  },
  {
    value: "vodafone_spain_pppoe",
    config: "vodafone_spain_pppoe",
    label: "voda_spain_dhcp",
  },
  {
    value: "singtel_singapore_dhcp",
    config: "singtel_singapore_dhcp",
    label: "singtel_singa_dhcp",
  },
  {
    value: "unifi_malaysia_dhcp",
    config: "unifi_malaysia_dhcp",
    label: "unifi_malaysia_dhcp",
  },
  {
    value: "maxis_malaysia_dhcp",
    config: "maxis_malaysia_dhcp",
    label: "maxis_malaysia_dhcp",
  },
];

export const wizard = {
  "orange.isp": isp_list,
  "orange.iptv_enable": commonMapping.intToBoolean,
  "account.question1": commonMapping.question1List,
  "account.question2": commonMapping.question2List,
  "wifi.smart_conn": commonMapping.intToBoolean,
};

export default wizard;
